import React, { useState, useEffect } from 'react';
import '../styles/Modal.css';

function EditHouseholdModal({ isOpen, onClose, onSubmit, household }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (household) {
      setName(household.name || '');
    }
    setError('');
  }, [household, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Household name is required');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(name.trim());
      onClose();
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to update household');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Household</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="error-message">{error}</div>}
            
            <div className="form-group">
              <label htmlFor="householdName">Household Name</label>
              <input
                type="text"
                id="householdName"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter household name"
                disabled={isSubmitting}
                autoFocus
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isSubmitting || !name.trim()}
            >
              {isSubmitting ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditHouseholdModal;
